<template>
  <div class="landlord-bill" v-title data-title="账单明细">
    <!-- <header>
      <img src="../../assets/images/pay-img/pay-record-img/icon-24-fanhui.png" alt="" @click="back"> 
      <p>
        账单明细
      </p>
    </header> -->
    <section>
      <!-- 年份 -->
      <div class="year" @click="showPicker = true">
        请选择时间<span></span>
        <input type="tex" v-model="date_value" disabled>
      </div>
      <!-- 具体月份收益 -->
      <div class="every-month" v-if="month_show">
        <p class="time">
          <img src="../../assets/images/pay-img/landlord-bill-img/rili.png" alt="">
          {{date_value}}
          <!-- <span class="s2">查看详情</span> -->
        </p>
        <div class="monthly-bill">
          <div class="left">
            <span>收</span>
          </div>
          <div class="middle">
            <p>总收益</p>
            <p>总收益</p>
          </div>
          <div class="right">
            + {{blii_price.count_earnings}}
          </div>
        </div>
        <div class="monthly-bill">
          <div class="left">
            <span style="background-color:#57DA29">支</span>
          </div>
          <div class="middle">
            <p>总支出</p>
            <p>总支出</p>
          </div>
          <div class="right">
            + {{blii_price.count_expenditure}}
          </div>
        </div>
        <div class="monthly-bill">
          <div class="left">
            <span>分</span>
          </div>
          <div class="middle">
            <p>总分成</p>
            <p>总分成</p>
          </div>
          <div class="right">
            + {{blii_price.count_deduction}}
          </div>
        </div>
      </div>
      <!-- 列表 -->
      <div class="landlord-content" v-for="(item,index) in bill_list" :key="index"> 
        <!-- 位置 时间 -->
        <div class="location-time">
          <span></span>
          <p class="address">
            {{item.housing_name}}
          </p>
          <p class="date">
            {{item.checketime}}
          </p>
        </div>
        <!-- 人员信息 -->
        <div class="personal-information">
          <p>
            入住人
          </p>
          <p>
            {{item.checkinperson}}
          </p>
          <p>
            {{item.sex === 1 ? '男' : '女' }}
          </p>
        </div>
        <!-- 入住时间 -->
        <div class="personal-information">
          <p>
            入住时间
          </p>
          <p>
            {{item.checkstime}}
          </p>
          <p>
            {{item.housing_days}}天
          </p>
        </div>
        <div class="personal-information">
          <p>
            离开时间
          </p>
          <p>
            {{item.checketime}}
          </p>
          <p>
            <!-- {{item.housing_days}}天 -->
          </p>
        </div>
        <!-- 收益金额 -->
        <div class="personal-information">
          <p>
            收益金额
          </p>
          <p>
            {{item.earnings | addPriceIcon}}
          </p>
        </div>
        <div class="personal-information">
          <p>
            分成金额
          </p>
          <p>
            {{item.deduction | addPriceIcon}}
          </p>
        </div>
        <!-- 来源 -->
        <div class="personal-information boeder-no" style="font-size:3rem">
          <p>
            客人来源
          </p>
          <p>
            {{item.source}}
          </p>
        </div>
        <div class="reconciliation" @click="reconciliationBtn(item.id)" v-if="item.status == 0">
          确认账单
        </div>
        <div class="reconciliation" v-else style="color:#CCCCCC;background:#6194FE;">
          已确认
        </div>
      </div>
    </section>
    <!-- <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup> -->
    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker
          v-model="currentDate"
          type="year-month"
          :min-date="minDate"
          :max-date="maxDate"
          :formatter="formatter"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
    </van-popup>
  </div>
</template>
<script>

import Vue from 'vue';
import { Picker, Popup, DatetimePicker, Toast } from 'vant';

Vue.use(Toast);
Vue.use(DatetimePicker);
Vue.use(Popup);
Vue.use(Picker);
export default {
  data(){
    return{
      bill_list: [], // 账单列表
      // year_value: '', // 时间
      // month_value: '', // 月份
      date_value:'',
      // columns: ['2020', '2021', '2022', '2023','2024','2025','2026','2027','2028','2029','2030','2031','2032','2033','2034','2035','2036','2037','2038','2039','2040'],
      showPicker: false,

      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2040, 10, 1),
      currentDate: new Date(),
      blii_price : {},
      month_show: false,
    }
  },
  created(){
    // 每月账单
    // this.$axios.get('http://members.kfm666666.net/api/housing/index/search?date=' + this.date_value).then((res)=>{
    //   // console.log(res.data.data)
    //   this.bill_list = res.data.data
    // })]
    // 默认时间
    let default_date = new Date()
    let default_year = default_date.getYear() + 1900
    let default_month = default_date.getMonth() + 1
    default_month = default_month > 9 ? default_month : ('0' + default_month)
    this.date_value = `${default_date.getYear() + 1900}-${default_month}`
    // console.log(this.date_value)
      this.$axios.get('http://members.kfm666666.net/api/housing/index/search?date=' + this.date_value).then((res)=>{
        // console.log(res.data.data)
        this.blii_price = res.data.data
        this.bill_list = res.data.data.data
        if(this.bill_list){
          this.month_show = true
        }
      })
  },
  methods:{
    // 返回
    back(){
      this.$router.push({
        path: '/pay-record',
        query:{
          active : 2
        }
      })
    },
    // 时间控件确定
    onConfirm(value) {
      let month = value.getMonth() + 1
      month = month > 9 ? month : ('0' + month)
      this.date_value = `${value.getYear() + 1900}-${month}`
      // console.log(this.date_value)
      this.showPicker = false;
      this.$axios.get('http://members.kfm666666.net/api/housing/index/search?date=' + this.date_value).then((res)=>{
        // console.log(res.data.data)
        this.blii_price = res.data.data
        this.bill_list = res.data.data.data
        console.log(this.bill_list)
        if(this.bill_list){
          this.month_show = true
        }else {
          this.month_show = false
        }
      })
    },
    // 时间格式
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
    // 对账
    reconciliationBtn(id){
      // console.log(id)
      this.$axios.get('http://members.kfm666666.net/api/housing/index/checking?id=' + id).then(res => {
        // console.log(res.data.msg)
        if(res.data.code == 1){
          Toast(res.data.msg);
          this.$axios.get('http://members.kfm666666.net/api/housing/index/search?date=' + this.date_value).then((res)=>{
            // console.log(res.data.data)
            this.blii_price = res.data.data
            this.bill_list = res.data.data.data
          })
        }else{
          Toast(res.data.msg);
        }
      })
    }
  },
  filters:{
    addPriceIcon(value){
      return '￥' + value
    }
  }
}
</script>
<style lang="less" scoped>
  .landlord-bill{
    width: 100%;
    // height: 100%;
    display: flex;
    flex-direction: column;
    header{
      width: 100%;
      height: .88rem;
      display: flex;
      align-items: center;
      border-bottom: .01rem #E4E4E4 solid;
      img{
        width: .18rem;
        height: .35rem;
        margin-left: .33rem;
      }
      p{
        width: 6.54rem;
        font-family: PingFang-SC-Bold;
        color: #333333;
        font-size: 0.36rem;
        font-weight: bold;
        text-align: center;
      }
    }
    section{
      width: 100%;
      height: 100%;
      flex: 1;
      overflow: scroll;
      // 时间 年份
      .year{
        line-height: .82rem;
        font-size: 0.28rem;
        font-family: Source Han Sans CN Regular, Source Han Sans CN Regular-Regular;
        font-weight: 400;
        color: #0088ff;
        margin-left: .3rem;
        span{
          color: #0088FF;
          margin-left: .18rem;
          // margin-right: .36rem;
        }
        input{
          background: none;
          border: none;
          width: 1.5rem;
          color: black;
          font-weight: bold;
        }
      }
      // 每月收益
      .every-month{
        width: 6.89rem;
        height: 4.77rem;
        margin: 0 auto;
        border-radius: .1rem;
        box-shadow: 0rem 0rem 0.1rem 0rem #cccccc;
        margin-bottom: .5rem;
        .time{
          width: 100%;
          height: .93rem;
          line-height: .93rem;
          font-size: 0.36rem;
          font-family: Source Han Sans CN Medium, Source Han Sans CN Medium-Medium;
          font-weight: 500;
          color: #333333;
          letter-spacing: 0.02rem;
          border-bottom: .01rem #eeeeee solid;
          img{
            width: .34rem;
            height: .34rem;
            margin-left: .26rem;
            margin-right: .31rem;
            float: left;
            margin-top: .26rem;
          }
          .s2{
            float: right;
            margin-right: .37rem;
            font-size: 0.3rem;
            font-family: Source Han Sans CN Medium, Source Han Sans CN Medium-Medium;
            font-weight: 500;
            color: #0088ff;
          }
        }
        // 收入支出
        .monthly-bill{
          width: 100%;
          .left{
            float: left;
            span{
              display: inline-block;
              width: .42rem;
              height: .42rem;
              text-align: center;
              line-height: .42rem;
              background: #FF3F3F;
              border-radius: 50%;
              font-size: 0.23rem;
              font-family: Source Han Sans CN Medium, Source Han Sans CN Medium-Medium;
              font-weight: 500;
              color: #ffffff;
              letter-spacing: 0.01rem;
              margin: .36rem .23rem;
            }
          }
          .middle{
            float: left;
            p{
              &:first-child{
                font-size: 0.29rem;
                line-height: .29rem;
                font-family: Source Han Sans CN Medium, Source Han Sans CN Medium-Medium;
                font-weight: 500;
                color: #333333;
                letter-spacing: 0.01rem;
                margin-top: .22rem;
              }
              &:last-child{
                font-size: 0.25rem;
                line-height: .25rem;
                font-family: Source Han Sans CN Normal, Source Han Sans CN Normal-Normal;
                font-weight: Normal;
                color: #999999;
                letter-spacing: 0.01rem;
                margin-top: .15rem;
                margin-bottom: .23rem;
              }
            }
          }
          .right{
            float: right;
            font-size: 0.26rem;
            font-family: Source Han Sans CN Medium, Source Han Sans CN Medium-Medium;
            font-weight: 800;
            color: #333333;
            margin-top: .48rem;
            margin-right: .4rem;
          }
        }
      }
      // 具体信息
      .landlord-content{
        width: 6.9rem;
        // height: 4.4rem;
        margin: 0 auto;
        margin-top: .4rem;
        box-shadow: 0px 0px .1rem 0px #cccccc;
        border-radius: .1rem;
        display: flex;
        flex-direction: column;
        flex: 1;
        // 位置时间
        .location-time{
          width: 100%;
          height: .38rem;
          margin-top: .3rem;
          font-size: .3rem;
          line-height: .38rem;
          margin-bottom: .13rem;
          span{
            display: inline-block;
            width: .08rem;
            height: .38rem;
            border-radius: .04rem;
            background-color: rgb(0, 136, 255);
            margin-left: .22rem;
            margin-right: .26rem;
            float: left;
          }
          .address{
            color: rgb(51, 51, 51);
            font-weight: bold;
            float: left;
          }
          .date{
            font-size: .24rem;
            color: rgb(102, 102, 102);
            float: right;
            margin-right: .3rem;
          }
        }
        // 入住人信息
        .personal-information{
          width: 6.3rem;
          height: .93rem;
          margin: 0 auto;
          border-bottom: .01rem rgb(228, 228, 228) dashed ;
          line-height: .9rem;
          p{
            font-size: .28rem;
            &:first-child{
              float: left;
              color: rgb(51, 51, 51);
              width: 1.2rem;
            }
            &:nth-child(2){
              float: left;
              margin-left: .33rem;
              color: rgb(102, 102, 102);
            }
            &:nth-child(3){
              float: right;
              color: rgb(0, 136, 255);
            }
          }
        }
        .reconciliation{
          width: 100%;
          height: .8rem;
          text-align: center;
          line-height: .8rem;
          font-size: 0.32rem;
          font-family: Source Han Sans CN Normal, Source Han Sans CN Normal-Normal;
          font-weight: Normal;
          color: #333333;
          background: linear-gradient(56deg,#796ffe, #6194fe);
          border-radius: 0 0 .1rem .1rem;
        }
        // .boeder-no{
        //   border: none;
        // }
      }
    }
  }
</style>